import React, { useContext } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import AdminPanel from './components/AdminPanel';
import KioskDashboard, { KioskActivate } from './components/KioskDashboard';
import UserSettingsPage from './components/UserSettingsPage';
import AuthContext from './AuthContext';

const LandingRoute = () => {
  const { authToken } = useContext(AuthContext);
  return <Navigate to={authToken ? '/dashboard' : '/login'} replace />;
};

const LoginRoute = () => {
  const { authToken } = useContext(AuthContext);
  return authToken ? <Navigate to="/dashboard" replace /> : <Login />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingRoute />} />
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/settings" element={<UserSettingsPage />} />
        <Route path="/admin" element={<Navigate to="/admin/filters" replace />} />
        <Route path="/admin/users" element={<AdminPanel section="users" />} />
        <Route path="/admin/filters" element={<AdminPanel section="filters" />} />
        <Route path="/admin/kiosks" element={<AdminPanel section="kiosk" />} />
        <Route path="/kiosk/activate/:token" element={<KioskActivate />} />
        <Route path="/kiosk/:slug" element={<KioskDashboard />} />
        <Route path="*" element={<LandingRoute />} />
      </Routes>
    </Router>
  );
}

export default App;
